export const SELF_APP_NAME                  = `${process.env.REACT_APP_NAME}`;
export const SELF_APP_AUTHOR                = `${process.env.REACT_APP_AUTHOR}`;
export const SELF_APP_HELP_TITLE            = `${process.env.REACT_APP_HELP_TITLE}`;
export const SELF_APP_HELP_INFO             = `${process.env.REACT_APP_HELP_INFO}`;

